var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VFormBuilder',{ref:"form",attrs:{"items":_vm.items,"initial-values":_vm.initialValues}},[_c('div',{attrs:{"slot":"item.privacy.after"},slot:"item.privacy.after"},[_c('router-link',{attrs:{"to":{ name: 'privacy.index' },"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('register.form.privacyLink')))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }